export default () => ({
  table: {
    display: 'grid',
    grid: '50px / 200px 200px',
  },
});
